import $ from 'jquery';

const navigation = function navigation() {
  const $header = $('.c-header');
  const ACTIVE = 'is-active';
  const navWithChildren = $('.c-main-nav__link.has-children');

  if ($header.length) {
    const $menuToggle = $header.find('#nav-toggle');
    const $menuWrapper = $header.find('.c-main-nav--wrapper');
    if ($menuToggle.length) {
      $menuToggle.on('click', () => {
        $menuToggle.toggleClass(ACTIVE);
        if ($menuWrapper.hasClass(ACTIVE)) {
          $menuWrapper.addClass('hide');
          setTimeout(() => {
            $menuWrapper.removeClass('is-active hide');
          }, 350);
        } else {
          $menuWrapper.addClass(ACTIVE);
        }
      });
    }
  }

  if (navWithChildren.length) {
    const subnavBackdrop = $('.c-header--subnav-backdrop');
    navWithChildren.click(ev => {
      ev.preventDefault();
      subnavBackdrop.fadeToggle();
      const $self = $(ev.target);
      $self.toggleClass(ACTIVE);
      const $dropdown = $($self.data('dropdown'));
      $dropdown.toggleClass(ACTIVE);
    });

    const allSubnavs = $('.c-main-nav__dropdown--wrapper');
    subnavBackdrop.click(() => {
      subnavBackdrop.fadeOut();
      navWithChildren.removeClass(ACTIVE);
      allSubnavs.removeClass(ACTIVE);
    });
  }
};
export default navigation;



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js